import React from 'react'

const Select = ({ state = 'a' }) => {
	return (
		<div>
			<select value={state}>
				<option value="default" disabled>
					-
				</option>
				<option value="a">A</option>
				<option value="b">B</option>
			</select>
		</div>
	)
}

const Options = ({ state = 'b' }) => {
	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<span>
				<input
					type="radio"
					value="a"
					name="form"
					checked={state === 'a'}
				/>
				<label for="a">A</label>
			</span>
			<span>
				<input
					type="radio"
					value="b"
					name="form"
					checked={state === 'b'}
				/>
				<label for="b">B</label>
			</span>
			<span>
				<input
					type="radio"
					value="c"
					name="form"
					checked={state === 'c'}
				/>
				<label for="c">C</label>
			</span>
		</div>
	)
}

const Button = ({ isPressed }) => {
	return (
		<div>
			<button
				style={{
					boxShadow: isPressed ? '0px 0px 16px 2px #2288FF' : 'none'
				}}>
				Poof
			</button>
		</div>
	)
}

export { Select, Options, Button }
